export default __webpack_public_path__ + "static/Keerthan_K_Acharya-25c90020589f2ef4f1e7485d4873c669.pdf";